import AlertMessage from './alert-message';
import Media from './media';
import Richtext from './richtext';
import Tile from './tile';

export default class BikeCtaBreaker {
  backgroundColor?: string;
  footer?: Media;
  image?: Media;
  paymentOptions: Tile[];
  tag?: Media;
  title?: Richtext;
  breadErrorMessage?: AlertMessage;
  bikePrice?: number;

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.title = props.title ? new Richtext(props.title) : undefined;
    this.image = props.image ? new Media(props.image) : undefined;
    this.tag = props.tag ? new Media(props.tag) : undefined;
    this.footer = props.footer ? new Media(props.footer) : undefined;
    this.paymentOptions =
      props.paymentOptionsCollection && props.paymentOptionsCollection.items
        ? props.paymentOptionsCollection.items.map(
            (option: any) => new Tile(option)
          )
        : undefined;
    this.breadErrorMessage = props.breadError
      ? new AlertMessage(props.breadError)
      : undefined;
    this.bikePrice = props.bikePrice;
  }
}
